export default __webpack_public_path__ + "images/unhappy.d24c575cfee73ea18360dcebffecb596.svg";